import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';

const BaseModal = ({
  open,
  onClose,
  onSubmit,
  loading,
  reportType,
  children,
  submitButtonText,
  submitDisabled = false,
  showCancel = true,
}) => {
  const handleSubmit = () => {
    if (!submitDisabled) {
      onSubmit();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        },
      }}
    >
      <DialogTitle
        sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          pb: 2,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>
              {reportType?.title} Configuration
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Select filters to generate the {reportType?.title.toLowerCase()}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>{children}</DialogContent>

      <DialogActions sx={{ p: 3, pt: 0 }}>
        {showCancel && (
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
            }}
          >
            Cancel
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading || submitDisabled}
          startIcon={loading ? <CircularProgress size={20} /> : null}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            '&:hover': {
              boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
            },
          }}
        >
          {loading ? 'Generating Report...' : submitButtonText || `Generate ${reportType?.title}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BaseModal;
